import { mapMedia } from './TimeLineMapper'
import { mapMentionType } from './TimelimeMentionMapper'
import { TimelineItemType } from 'store/types'
import { GroupMentionResponse, TimelineMentionResponse } from 'api/timeline/types/response'

const mapMentions = (
  mentions: TimelineMentionResponse[],
  compressedMention: GroupMentionResponse,
  id: string
) => {
  return {
    type: TimelineItemType.Compressed,
    id,
    data: {
      appName: compressedMention.appName,
      groupName: compressedMention.groupName,
      backgroundStart: compressedMention.backgroundStart,
      backgroundEnd: compressedMention.backgroundEnd,
      logo: compressedMention.logo,
      unreadMessageCount: compressedMention.unreadMessageCount,
      mentionType: compressedMention.mentionType,
      mentions: mentions.map((item) => ({
        id: item.id,
        lastMessage: item.lastMessage,
        lastSeenMessageTime: item.lastSeenMessageTime,
        withinGroup: item.recipient !== null,
        media: mapMedia(item.attachment),
        title: item.title,
        messages: item.messages,
        mentionType: mapMentionType(item.mentionType),
        isHandler: item.isHandler,
        isAnon: item.isAnonymous,
        appSettingId: item.appSettingId,
        recipient: item.recipient
          ? item.recipient
          : {
              id: item.id,
              logo: compressedMention.logo,
              fullName: compressedMention.groupName,
              position: null,
              phoneNumber: '',
              isGroup: true,
            },
        sender: item.sender,
      })),
    },
  }
}

export const compressedMentionMapper = (compressedMention: GroupMentionResponse, id: string) => {
  return mapMentions(compressedMention.mentions, compressedMention, id)
}
